import { HttpClient } from '@/shared/lib/http-client';

export const registerUser = async({
  type_id,
  email,
  name,
  company_name = null,
  erdpy_code = null,
  surname = null,
  patronymic = null,
  uin = null,
  city_id = null,
  street = null,
  house = null,
  apartment = null,
  birthday = null,
  phone = null,
  activity_type_id = null,
  is_show_bonus = null,
  cf_token = null,
}) => {
  const response = await HttpClient.post('/auth/register', {
    typeId: type_id,
    email,
    name,
    companyName: company_name,
    erdpyCode: erdpy_code,
    surname,
    patronymic,
    uin,
    cityId: city_id,
    street,
    house,
    apartment,
    birthday,
    phone,
    activityTypeId: activity_type_id,
    cf_token,
    settings: {
      isShowBonus: is_show_bonus,
    },
  });

  return response.data;
};
